// [MCV-1949] Fee note on the pre-submit review step. The rates mirror mcv-api
// `services/billing/fees.py` and the HLX Launch Pricing in `pages/organizations/Benefits.tsx`;
// change them together.

type ProviderTier = 'PHYSICIAN' | 'APP' | 'NURSE' | 'ALLIED';

const PLACEMENT_FEE_BY_TIER: Record<ProviderTier, string> = {
  PHYSICIAN: '$5,000',
  APP: '$7,000',
  NURSE: '$5,000',
  ALLIED: '$2,000',
};

const TIER_LABEL: Record<ProviderTier, string> = {
  PHYSICIAN: 'physician',
  APP: 'advanced practice provider',
  NURSE: 'nurse',
  ALLIED: 'allied health professional',
};

// Provider category ids: 1 Physician, 2 Advanced practice provider, 3 Nurse; everything else Allied.
const TIER_BY_CATEGORY_ID: Record<number, ProviderTier> = { 1: 'PHYSICIAN', 2: 'APP', 3: 'NURSE' };

// Same split as mcv-api `engagement_type_for_job_type`: anything else, unknown included, is PERM.
const TEMP_JOB_TYPES = new Set(['Locums Tenens', 'Part Time']);

export const B2B_LISTING_FEE_NOTE =
  '*There is a 1.5% platform fee on the monthly contract value of completed B2B listings, billed monthly for the first 12 months, regardless of whether the contract is completed on the platform or offline.';

const TEMP_LOCUMS_FEE_NOTE =
  '*There is a 3% platform fee on the monthly contract value of completed locum tenens and part-time listings, billed monthly for up to 12 months, regardless of whether the contract is completed on the platform or offline.';

export const jobListingFeeNote = (
  jobType: string | null | undefined,
  providerCategoryId: number | null | undefined
): string => {
  if (jobType && TEMP_JOB_TYPES.has(jobType)) return TEMP_LOCUMS_FEE_NOTE;
  const tier = (providerCategoryId != null && TIER_BY_CATEGORY_ID[providerCategoryId]) || 'ALLIED';
  return `*There is a ${PLACEMENT_FEE_BY_TIER[tier]} placement fee for a permanent ${TIER_LABEL[tier]} placement, regardless of whether the placement is completed on the platform or offline.`;
};
